import store from '../store';
import * as actions from "./dashboardTypes";
import { handleAxiosPost, handleAxiosGet } from '../axiosHelper';

export const getGeneralSearch = async (item) => {
    let url = '/Dashboard/GetGeneralSearch';
    let params = item;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SETGENERALSEARCHLIST, payload: { list: responseData } });

        return responseData;
    } else {
        return responseData;
    }
};

export const getCustomerStatement = async (item) => {
    let url = '/Dashboard/GetCustomerStatement';
    let params = item;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        return responseData.data;
    } else {
        return responseData;
    }
};

export const getDashboardTileData = async (item) => {
    let url = '/Dashboard/GetDashboardTileData';
    let params = item;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        return responseData;
    } else {
        return responseData;
    }
};

export const getOrdersList = async (item) => {
    let url = '/Dashboard/GetOrdersList';
    let params = item;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SETORDERSLIST, payload: { list: responseData } });

        return responseData;
    } else {
        return responseData;
    }
};

export const getMyEquipmentList = async (item) => {
    let url = '/Dashboard/GetMyEquipmentList';
    let params = item;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SETMYEQUIPMENTLIST, payload: { list: responseData } });

        return responseData;
    } else {
        return responseData;
    }
};

export const getInvoicesList = async (item) => {
    let url = '/Dashboard/GetInvoicesList';
    let params = item;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SETINVOICESLIST, payload: { list: responseData } });

        return responseData;
    } else {
        return responseData;
    }
};

export const getDeliveriesList = async (item) => {
    let url = '/Dashboard/GetDeliveriesList';
    let params = item;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SETDELIVERIESLIST, payload: { list: responseData } });

        return responseData;
    } else {
        return responseData;
    }
};

export const getEquipmentInfo = async (item) => {
    let url = '/Dashboard/GetEquipmentInfo';
    let params = item;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SETEQUIPMENTINFO, payload: { list: responseData } });

        return responseData;
    } else {
        return responseData;
    }
};

export const getMeterBillingInfo = async (item) => {
    let url = '/Dashboard/GetMeterBillingInfo';
    let params = item;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SETMETERBILLINGINFO, payload: { list: responseData } });

        return responseData;
    } else {
        return responseData;
    }
};

export const getServiceCallInfo = async (item) => {
    let url = '/Dashboard/GetServiceCallInfo';
    let params = item;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SETSERVICECALLINFO, payload: { list: responseData } });

        return responseData;
    } else {
        return responseData;
    }
};

export const getOrderHistoryInfo = async (item) => {
    let url = '/Dashboard/GetOrderHistoryInfo';
    let params = item;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SETORDERHISTORYINFO, payload: { list: responseData } });

        return responseData;
    } else {
        return responseData;
    }
};